const mapboxAccessToken="pk.eyJ1IjoianVjaHVud2VpIiwiYSI6ImNsZHM3YnhvZzFhN3M0MXJwOXA4MWNwc3gifQ.QpQagkFMY0f2gZNKWZAlLg";

mapboxgl.accessToken = mapboxAccessToken;

/**
 * Add the map to the page
 */
const map = new mapboxgl.Map({
    container: "map",
    style: "mapbox://styles/mapbox/streets-v12",
    center: [11.58723400,48.16179800], //[-117.87112800,33.61628000],//
    zoom: 13,
    scrollZoom: true,
});
map.addControl(new mapboxgl.NavigationControl());
const geolocate = new mapboxgl.GeolocateControl({
    positionOptions: {
        enableHighAccuracy: true,
    },
    // When active the map will receive updates to the device's location as it changes.
    trackUserLocation: true,
    // Draw an arrow next to the location dot to indicate which direction the device is heading.
    showUserHeading: true,
});
map.addControl(geolocate);

/**
 **/
var allStores, currentLocation;
var countries = [],
    cities = {};

const sideBar = document.getElementById("mapSidebar");
const mapDiv = document.getElementById('map');

const listings = document.getElementById("listings");

const milesSelect = document.getElementById("miles-select");
const searchUnit = document.getElementById('search-unit');

const loading = document.getElementById('loading');
var markers = [];
var noStores = false;

function setLanguage(language) {
    // Use setLayoutProperty to set the value of a layout property in a style layer.
    // The three arguments are the id of the layer, the name of the layout property,
    // and the new property value.
    map.setLayoutProperty('country-label', 'text-field', [
        'get',
        `name_${language}`
    ]);
}

/**
 * Wait until the map loads to make changes to the map.
 */
map.on("load", () => {   

     const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        marker: true,
        // bbox: [-77.210763, 38.803367, -76.853675, 39.052643]
    });

    /**
     * Add all the things to the page:
     * - The location listings on the side of the page
     * - The search box (MapboxGeocoder) onto the map
     * - The markers onto the map
     */
    // buildLocationList(stores);
    //  map.addControl(geocoder, 'top-left');
    document.getElementById("geocoder").appendChild(geocoder.onAdd(map));

    /**
     * Listen for when a geocoder result is returned. When one is returned:
     * - Calculate distances
     * - Sort stores by distance
     * - Rebuild the listings
     * - Adjust the map camera
     * - Open a popup for the closest store
     * - Highlight the listing for the closest store.
     */
    geocoder.on("result", (event) => {
        /* Get the coordinate of the search result */
        currentLocation = event.result.geometry;

        var isCA=false;
        if(event.result.context){
            event.result.context.forEach(con => {
                if(con.short_code=="US-CA")
                    isCA=true;
            });
        }

        // sideBar.classList.remove("hidden");
        sortAndShowStores(currentLocation, isCA);
/*
        // 创建 XMLHttpRequest 对象
        var xhr = new XMLHttpRequest();

        // 配置请求
        xhr.open('POST', 'https://us.ai.appliedbiology.com.cn:999/api/da/locator', true);

        // 设置请求头
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhr.setRequestHeader('Authorization', 'Bearer your_token_here');

        // 发送数据
        var data = JSON.stringify({ title: 'foo', body: 'bar', userId: 1 });
        xhr.send(data);
*/

        if(event.result?.matching_place_name){
            fetch('https://us.ai.appliedbiology.com.cn:999/api/da/locator', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer Dfdadferhiywrw83kcdfaiASDLyDfiereworw3'
                },
                credentials: 'omit',
                body: JSON.stringify({ keyword: event.result?.matching_text, city: event.result?.matching_place_name})
                })                
                .catch(error => console.error('Error:', error));
        }        
    });
 // add an event listener to handle the `retrieve` event
    geocoder.on('retrieve', (e) => {
       console.log(e)
      
    });
    /*
     // instantiate a geocoder
    const geocoder = new mapboxsearch.MapboxGeocoder()

    // set the mapbox access token, geocoding API options
    geocoder.accessToken = mapboxAccessToken
    // geocoder.options = {
    //   language: 'es'
    // }

    // set the mapboxgl library to use for markers and enable the marker functionality
    geocoder.mapboxgl = mapboxgl
    geocoder.marker = true

    // bind the geocoder instance to the map instance
    geocoder.bindMap(map)

    // add the geocoder instance to the DOM
    document.getElementById('geocoder').appendChild(geocoder)
   */
    // add an event listener to handle the `retrieve` event
    // geocoder.addEventListener('retrieve', (e) => {
    //     const feature = e.detail;
    //     /* Get the coordinate of the search result */
    //     currentLocation = feature.geometry;
    //     // sideBar.classList.remove("hidden");
    //     sortAndShowStores(currentLocation);
    // });
    

     var ginput = document.querySelector('.geocoder input');
    ginput.setAttribute('placeholder', "Search by ZIP code , city or state")

});
function sortAndShowStores(point, isCA) {
    if (loading)
        loading.style.display = "block";

    noStores = false;

    //getFilters
    var checkboxes = productFilter.querySelectorAll(
        "input[name='store-category']:checked"
    );
    var miles = Number(milesSelect.value);

    var selectedCategories = [];
    checkboxes.forEach((x) => selectedCategories.push(x.value));
    var selectedServices = [];
    checkboxes = serviceFilter.querySelectorAll("input[name='store-service']:checked");
    checkboxes.forEach((x) => selectedServices.push(x.value));
    
    var allProducts = selectedCategories.length == 2;
    var allServices = selectedServices.length == 4;

    /**
     * Calculate distances:
     * For each store, use turf.disance to calculate the distance
     * in miles between the searchResult and the store. Assign the
     * calculated value to a property called `distance`.
     */
    const options = { units: searchUnit.value };
   
    var miles = Number(milesSelect.value);

    var stores = [];
    for (var store of allStores) {
        var match = false;
        if (point) {
            store.distance = turf.distance(
                point,
                {
                    "type": "Point",
                    "coordinates": [store.longitude, store.latitude]
                },
                options
            );
            if (miles == 0 || (miles != 0 && miles > store.distance) || (isCA && store.name=="Follea Flagship Showroom - Daniel Alain")) match = true;
        } else {
            match = true;
        }
        if (match){
            if(allProducts && allServices)
                stores.push(store);
            else{
                if(!store.products || !store.tags)
                    match = false;
                if(match){
                    var ps = store.products.split(',');
                    var s = store.tags.split(',');
                    if(ps.some((i) => selectedCategories.includes(i)) && s.some((i) => selectedServices.includes(i)))
                        stores.push(store)
                }
            }
        }           

    }

    /**
     * Sort stores by distance from closest to the `searchResult`
     * to furthest.
     */
    if (point) {
        stores.sort((a, b) => {
            if (a.distance > b.distance) {
                return 1;
            }
            if (a.distance < b.distance) {
                return -1;
            }
            return 0; // a must be equal to b
        });
    }

    /**
     * Rebuild the listings:
     * Remove the existing listings and build the location
     * list again using the newly sorted stores.
     */
    //while (listings.firstChild) {
    //    listings.removeChild(listings.firstChild);
    //}

    if(stores.length == 0)
        noStores = true;
    
    // if(!noStores){
    //     var fistStore = stores[0];
    //     noStores = fistStore.distance > 50; //大于50miles, 显示弹窗
    // }
    
    if(noStores){
        showModal();
    }

    buildLocationList(stores);

    /* Open a popup for the closest store. */
    if (stores.length > 0) {
        createPopUp(stores[0]);

        /** Highlight the listing for the closest store. */
        const activeListing = document.getElementById(
            `listing-${stores[0].id}`
        );
        activeListing.classList.add("active");

        /**
         * Adjust the map camera:
         * Get a bbox that contains both the geocoder result and
         * the closest store. Fit the bounds to that bbox.
         */
        if (stores[0].distance < 500) {
            const bbox = getBbox(stores, 0, point);
            map.fitBounds(bbox, {
                padding: 100,
            });
        }
    }
    if (loading)
        loading.style.display = "none";
}

/**
 * Using the coordinates (lng, lat) for
 * (1) the search result and
 * (2) the closest store
 * construct a bbox that will contain both points
 */
function getBbox(sortedStores, storeIdentifier, searchResult) {
    const lats = [
        sortedStores[storeIdentifier].latitude,
        searchResult.coordinates[1],
    ];
    const lons = [
        sortedStores[storeIdentifier].longitude,
        searchResult.coordinates[0],
    ];
    const sortedLons = lons.sort((a, b) => {
        if (a > b) {
            return 1;
        }
        if (a.distance < b.distance) {
            return -1;
        }
        return 0;
    });
    const sortedLats = lats.sort((a, b) => {
        if (a > b) {
            return 1;
        }
        if (a.distance < b.distance) {
            return -1;
        }
        return 0;
    });
    return [
        [sortedLons[0], sortedLats[0]],
        [sortedLons[1], sortedLats[1]],
    ];
}

/**
 * Add a marker to the map for every store listing.
 **/

function addMarkers(stores) {
    markers.forEach(m => m.remove());
    /*
      var flagDiv=document.createElement("div");
        flagDiv.id = `marker-flag`;
        flagDiv.className = "marker";
      var flag= new mapboxgl.Marker(flagDiv, { offset: [0, -23] })
          .setLngLat([ -117.87120331774904,33.616534383400634])
          .addTo(map);
        markers.push(flag);
      */
    /* For each feature in the GeoJSON object above: */
    for (const marker of stores) {
        /* Create a div element for the marker. */
        const el = document.createElement("div");
        /* Assign a unique `id` to the marker. */
        el.id = `marker-${marker.id}`;
        /* Assign the `marker` class to each marker for styling. */
        el.className = "marker";

        /**
         * Create a marker using the div element
         * defined above and add it to the map.
         **/
        var m = new mapboxgl.Marker(el, { offset: [0, -23] })
            .setLngLat([marker.longitude, marker.latitude])
            .addTo(map);
        markers.push(m);

        /**
         * Listen to the element and when it is clicked, do three things:
         * 1. Fly to the point
         * 2. Close all other popups and display popup for clicked store
         * 3. Highlight listing in sidebar (and remove highlight for all other listings)
         **/
        el.addEventListener("click", (e) => {
            e.stopPropagation();
            e.preventDefault();

            flyToStore(marker);
            createPopUp(marker);
            const activeItem = document.getElementsByClassName("active");            

            if (activeItem[0]) {
                activeItem[0].classList.remove("active");
            }
            const listing = document.getElementById(
                `listing-${marker.id}`
            );
            listing.classList.add("active");
           
        });
    }
}

/* filter toggle */

milesSelect.addEventListener("change", function () {
    if (currentLocation) sortAndShowStores(currentLocation);
});

searchUnit.addEventListener("change", function () {
    if (currentLocation) sortAndShowStores(currentLocation);
});

const filterToggle = document.getElementById("locator-filter-toggle");
const filter = document.getElementById("filter-area");
filterToggle.addEventListener("click", function () {
  filter.classList.toggle("hidden");
  filterToggle.classList.toggle('open');
});

const params = new URLSearchParams(window.location.search);
const hide = params.get('hide'); 
if(hide){
    filterToggle.classList.add('hidden');
}

const productFilter= document.getElementById('product-filter');
const serviceFilter =document.getElementById('service-filter');

function buildFilterContent(){
    const categories = ["Wigs", "Toppers"];
    categories.forEach((x) => {
        const div = productFilter.appendChild(document.createElement("div"))
        div.className="form-check";
        
        const input = div.appendChild(document.createElement("input"));
        input.type = "checkbox";
        input.name = "store-category";
        input.value = x;
        input.id = 'chk'+x;
        input.className="form-check-input";
        input.setAttribute("checked", true); //.checked = true;
        const label = document.createElement("label");
        label.innerHTML = x;
        label.className='form-check-label';
        label.setAttribute('for', input.id);

        div.appendChild(label);

        input.addEventListener("check", function () {
            sortAndShowStores(currentLocation);
        });
        
    });

  const services = [
    "Cutting",
    "Coloring",
    "Washing/Styling",
    "Alterations",
  ];
  services.forEach((x) => {
    const div = serviceFilter.appendChild(document.createElement("div"))
    div.className="form-check";
    
    const input = div.appendChild(document.createElement("input"));
    input.type = "checkbox";
    input.name = "store-service";
    input.className='form-check-input';
    input.value = x;
    input.id = 'chk'+x;
    input.setAttribute("checked", true); //.checked = true;
    input.addEventListener("change", function () {
      sortAndShowStores(currentLocation);
    });

    const label = document.createElement("label");
    label.setAttribute('for', input.id);
    label.appendChild(getServiceIcon(x));
    label.innerHTML += x;
    div.appendChild(label);
  });
}

buildFilterContent();

/**
 * Add a listing for each store to the sidebar.
 **/
function buildLocationList(stores) {
    addMarkers(stores);

    listings.scrollTop =0;
    
    if (stores.length == 0) {
        listings.innerText = "No results";
        return;
    }
    else
        listings.innerText = "";
    //console.log(stores);
    for (const store of stores) {
        /* Add a new listing section to the sidebar. */
        //const listings = document.getElementById("listings");

        const listing = listings.appendChild(document.createElement("div"));
        /* Assign a unique `id` to the listing. */
        listing.id = `listing-${store.id}`;
        /* Assign the `item` class to each listing for styling. */
        listing.className = "item";

        var title = document.createElement('div');
        title.innerHTML=`<h3>${store.name}</h3>`;
        
        listing.appendChild(title)

        var mainInfo = document.createElement('div');
        mainInfo.className="main-info";

        listing.appendChild(mainInfo);

        const left = mainInfo.appendChild(document.createElement("div"));
        left.className = "left";
        left.innerHTML = `<p>${getStoreText(store)}</p>`;      
        if(store.bookingUrl)
            left.innerHTML += `<a href="${store.bookingUrl}" target="_blank">BOOK NOW</a>`;

        //left.innerHTML += `<a href='/pages/facts?name=${store.title}' target="_blank">GET THE FACTS</a>`;

        const right = mainInfo.appendChild(document.createElement("div"));
        right.className = "right";
        const category = right.appendChild(document.createElement("div"));
        category.className = "store-category";

        store.products =store.products || 'Wigs,Toppers'

        var products = store.products;
        products.split(',').forEach((x) => {
            var span = category.appendChild(document.createElement("span"));
            span.innerHTML = x;
        });

        const services = right.appendChild(document.createElement("div"));
        services.className = "store-service";

        var tags = store.tags || ""
        if(tags){
            store.tags.split(',').forEach((x) => {
                services.appendChild(getServiceIcon(x));
            });
        }      

        let dirDiv = right.appendChild(document.createElement('div'));

        if (store.distance) {
            const roundedDistance = Math.round(store.distance * 100) / 100;
            dirDiv.innerHTML += `<div>${roundedDistance} ${searchUnit.value}</div>`;
        }
        const dir = dirDiv.appendChild(document.createElement("a"));
        dir.href =
            "https://www.google.com/maps/dir/CURRENT+LOCATION/" +
            `${store.fullAddress}`;
        dir.innerHTML = "GET DIRECTIONS";
        dir.target = "_blank";
        dir.addEventListener("click", function (e) {
            e.stopImmediatePropagation();
        });
        if (loading)
            loading.style.display = "none";

        /* Add the link to the individual listing created above. */
        /*
        const link = listing.appendChild(document.createElement("a"));
        link.href = "#";
        link.className = "title";
        link.id = `link-${store.id}`;
        link.innerHTML = `<img src='${store.image}'></img>`;
    */
        //link.innerHTML = `${store.address}`;

        /* Add details to the individual listing. */
        /*
        const details = listing.appendChild(document.createElement("div"));
        details.innerHTML = `${store.address}`;
        details.innerHTML += `${store.city}`;
        if (store.phone) {
          details.innerHTML += ` &middot; ${store.phoneFormatted}`;
        }
        */

        /**
         * Listen to the element and when it is clicked, do four things:
         * 1. Update the `currentFeature` to the store associated with the clicked link
         * 2. Fly to the point
         * 3. Close all other popups and display popup for clicked store
         * 4. Highlight listing in sidebar (and remove highlight for all other listings)
         **/
        listing.addEventListener("click", function (e) {
            if(e.target.nodeName != 'A'){
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
            }
            for (const feature of stores) {
                if (this.id === `listing-${feature.id}`) {
                    flyToStore(feature);
                    createPopUp(feature);
                }
            }
            const activeItem = listings.getElementsByClassName("active");
            if (activeItem[0]) {
                activeItem[0].classList.remove("active");
            }
            this.classList.add("active");
            
        });
    }
}

function getServiceIcon(x) {
    var span = document.createElement("span");
    var t;
    if (x.includes("Cutting")) {
        t = "cu";
        span.className = "service-hc";
    } else if (x.includes("Coloring")) {
        t = "co";
        span.className = "service-ss";
    } else if (x.includes("Washing")) {
        t = "wa";
        span.className = "service-a";
    } else if (x.includes("Alterations")) {
        t = "al";
        span.className = "service-mb";
    }
    span.innerHTML = t;
    return span;
}
/**
 * Use Mapbox GL JS's `flyTo` to move the camera smoothly
 * a given center point.
 **/
function flyToStore(store) {
    map.flyTo({
        center: [store.longitude, store.latitude],
        zoom: 14,
        padding: {bottom:100}
    });
}

function getStoreText(store) {
  var info=[store.fullAddress];
  if(store.telephone)
    info.push(`<a href="tel:${store.telephone}"> ${store.telephone}</a>`);
  if(store.website)
    info.push(`<a href="${store.website}" target="_blank">${store.website}</a>`);
  if(store.email)
    info.push(`<a href="mailto:${store.email}"> ${store.email}</a>`)

  return info.join('<br>');
}

/**
 * Create a Mapbox GL JS `Popup`.
 **/
function createPopUp(store) {
    const popUps = document.getElementsByClassName("mapboxgl-popup");
    if (popUps[0]) popUps[0].remove();

    const popup = new mapboxgl.Popup({ closeOnClick: false,focusAfterOpen: false })
        .setLngLat([store.longitude, store.latitude])
        .setHTML(
            `<h3>${store.name}</h3><p>${getStoreText(store)}</p>
      <a href ="https://www.google.com/maps/dir/CURRENT+LOCATION/${store.fullAddress}" target="_blank">GET DIRECTIONS</a>`
        )
        .addTo(map);
}

function showPosition(position) {
    // 调用 Mapbox 逆地理编码 API
    var isCA=false;
    fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${position.coords.longitude},${position.coords.latitude}.json?access_token=${mapboxAccessToken}&language=en`)
    .then(res => res.json())
    .then(data => {
        if (data.features && data.features.length > 0) {
        // 找到城市信息
        const cityFeature = data.features.find(f => f.place_type.includes('place'));
        isCA = data.features.find(f => f.short_code=="US-CA");

        if(cityFeature)
          fetch('https://us.ai.appliedbiology.com.cn:999/api/da/locator', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer Dfdadferhiywrw83kcdfaiASDLyDfiereworw3'
                },
                credentials: 'omit',
                body: JSON.stringify({ origin: "auto", city: cityFeature.place_name})
                }).catch(error => console.error('Error:', error))
                ;       
        }
    })
    .catch(err => console.error(err));    

    map.flyTo({
        center: [position.coords.longitude, position.coords.latitude],
        zoom: 14,
    });
    currentLocation = {
        type: "Point",
        coordinates: [position.coords.longitude, position.coords.latitude],
    };
    sortAndShowStores(currentLocation, isCA);
}

function showError(error) {
    console.log(error);
    buildLocationList(allStores);
    flyToStore({longitude:-117.87112800,latitude:33.61628000})
}

// Set an event listener that fires
// when a geolocate event occurs.
geolocate.on("geolocate", () => {
    console.log("A geolocate event has occurred.");
});

/*
const listButton = document.getElementById('list-button');
const mapButton = document.getElementById('map-button');
listButton.addEventListener('click', function (e) {
    if (!e.target.classList.contains('active')) {
        e.target.classList.add('active');
        sideBar.classList.add('active');
    }
    mapButton.classList.remove('active');
    mapDiv.classList.remove('active');
});
mapButton.addEventListener('click', function (e) {
    if (!e.target.classList.contains('active')) {
        e.target.classList.add('active');
        mapDiv.classList.add('active');
    }
    listButton.classList.remove('active');
    sideBar.classList.remove('active');
})
*/

fetch(
    storeUrl
)
    .then((res) => (stores = res.json()))
    .then((out) => {
        allStores = out;
// alert('start build')
        if (navigator.geolocation) {
            // alert('get location')
            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 15000,
            };
            navigator.geolocation.getCurrentPosition(
                showPosition,
                showError,
                options
            );
        } else{
            buildLocationList(allStores);
            flyToStore({longitude:-117.87112800,latitude:33.61628000})
        }
            
    })
    .catch((err) => {console.error(err); alert(err)});


/**弹窗 */
var modal = document.getElementById('noResultsModal');
document.body.appendChild(modal);

function showModal(){
    noResultsModal.style.display="flex";
    document.body.classList.add('modal-open');
}
function closeModal(){
    noResultsModal.style.display="none";
    document.body.classList.remove('modal-open');
}